<template>
  <div @click="hideKeyboard" :class="[$style.wrapper, !isOpen ? $style.hide : null]">
    <div :class="$style.content" :style="contentStyle">
      <div v-if="this.isOpen" :class="$style.back" @click="backToCatalog">
        <img src="../assets/img/back.svg" alt="" />
      </div>

      <div v-if="photoUrls.length" :class="$style.photo">
        <div
          v-for="(photo, index) in photoUrls"
          :key="'old-' + index"
          :class="$style.photo_preview"
        >
          <img :src="photo" alt="Фото" :class="$style.photo_item" />
          <button :class="$style.remove_button" @click="removeOldPhoto(index)">
            <img src="../assets/img/delete.svg" alt="" :class="$style.delete_icon" />Удалить фото
          </button>
        </div>
      </div>

      <div v-if="newPhotoUrls.length" :class="$style.photo">
        <div
          v-for="(photo, index) in newPhotoUrls"
          :key="'new-' + index"
          :class="$style.photo_preview"
        >
          <img :src="photo" alt="Фото" :class="$style.photo_item" />
          <button :class="$style.remove_button" @click="removeNewPhoto(index)">
            <img src="../assets/img/delete.svg" alt="" :class="$style.delete_icon" />Удалить фото
          </button>
        </div>
      </div>

      <div :class="$style.custom">
        <label for="photo_urls" :class="$style.custom_button" @click="triggerHapticFeedback">
          <img src="../assets/img/add_photo.svg" alt="" :class="$style.img" />Добавить фото
        </label>
        <input
          type="file"
          id="photo_urls"
          @change="handleFileChange"
          :class="$style.hidden"
          multiple
        />
      </div>

      <LayoutEditor v-model="layoutItems" input-id="edit_layouts" />

      <div :class="$style.field">
        <p :class="$style.title">Проект</p>
        <input
          v-model="project"
          type="text"
          placeholder="Тег, клиентам не виден"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
        />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Категория</p>
        <select
          v-model="category"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
        >
          <option v-for="option in categories" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Название:</p>
        <input
          v-model="header"
          type="text"
          ref="header"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
        />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Описание</p>
        <div :class="$style.editor_container">
          <Editor
            v-model="description"
            type="text"
            ref="description"
            @focus="handleFocus"
            @blur="handleBlur"
            @selectionChange="handleSelectionChange"
            :modules="editorModules"
            :class="$style.editor"
          />
        </div>
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Цена</p>
        <input
          v-model="formattedPrice"
          type="text"
          ref="price"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
          @input="formatPriceInput"
        />
      </div>

      <div :class="$style.buttons">
        <button :class="$style.button" @click="submitForm">
          <img src="../assets/img/plus.svg" alt="" :class="$style.img" />Сохранить изменения
        </button>
        <button :class="$style.remove_card" @click="deleteCard">Удалить карточку</button>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from 'primevue/editor';
import LayoutEditor from './LayoutEditor.vue';

export default {
  components: { Editor, LayoutEditor },
  props: {
    object: Object,
  },
  data() {
    return {
      check: false,
      isOpen: true,
      category: this.object.category || 'Новостройки',
      categories: ['Новостройки', 'Вторичные', 'Коммерция'],
      photoUrls: this.object.photo_urls || [],
      newPhotos: [],
      newPhotoUrls: [],
      layoutItems: (this.object.layouts || []).map((l) => ({
        id: l.id,
        preview: l.url,
        kind: l.kind || 'Студия',
        area: l.area ? String(l.area).replace('.', ',') : '',
        price: l.price ? String(l.price).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '',
        discount: l.discount ? String(l.discount) : '',
        building: l.building || '',
        floor: l.floor || '',
        view: l.view || '',
      })),
      project: this.object.project || '',
      header: this.object.header || '',
      description: this.object.description || '',
      contentStyle: {},
      price: this.object.price || '',
      editorModules: {
        toolbar: [['bold', 'underline', 'strike']],
      },
      formattedPrice:
        this.object.formattedPrice ||
        (this.object.price ? this.formatPrice(this.object.price) : ''),
    };
  },
  mounted() {
    this.description = this.object.description || '';
    this.check = false;
    setTimeout(() => {
      if (this.$refs.description && this.$refs.description.quill) {
        this.$refs.description.quill.root.innerHTML = this.description || '';
        this.check = true;
      }
    }, 200);
  },
  updated() {
    if (this.$refs.description && this.$refs.description.quill && !this.check) {
      this.$refs.description.quill.root.innerHTML = this.description || '';
      this.check = true;
    }
  },
  watch: {
    description(newDescription) {
      if (this.$refs.description && this.$refs.description.quill && !this.check) {
        this.$refs.description.quill.root.innerHTML = newDescription || '';
        this.check = true;
      }
    },
    object: {
      handler(newObject) {
        this.description = newObject.description || '';
      },
      immediate: true,
    },
  },
  methods: {
    triggerHapticFeedback() {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
    },

    handleFileChange(event) {
      this.triggerHapticFeedback();
      const files = Array.from(event.target.files);
      files.forEach((file) => {
        this.newPhotos.push(file);
        this.newPhotoUrls.push(URL.createObjectURL(file));
      });
    },

    handleSelectionChange($event) {
      if ($event.range) {
        this.contentStyle = {
          padding: '70px 16px 300px 16px',
        };
      } else {
        window.scrollTo(0, 0);
        this.contentStyle = {
          padding: '70px 16px 16px 16px',
        };
      }
    },

    async deleteCard() {
      this.triggerHapticFeedback();
      try {
        await this.$store.dispatch('deleteObject', this.object.id);
        this.backToCatalog();
        console.log('Объект удалён');
      } catch (error) {
        console.log('Ошибка при удалении:', error);
      }
      this.backToCatalog();
    },

    removeOldPhoto(index) {
      this.triggerHapticFeedback();
      this.photoUrls.splice(index, 1);
    },

    removeNewPhoto(index) {
      this.triggerHapticFeedback();
      this.newPhotos.splice(index, 1);
      this.newPhotoUrls.splice(index, 1);
    },

    formatPrice(price) {
      return price
        .toString()
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    formatPriceInput() {
      let value = this.formattedPrice.replace(/\D/g, '');
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      this.formattedPrice = value;
      this.price = value.replace(/\s/g, '');
    },

    async submitForm() {
      this.check = false;
      this.triggerHapticFeedback();
      const formData = new FormData();

      formData.append('description', this.description);

      formData.append('id', this.object.id);
      formData.append('category', this.category);
      formData.append('header', this.header);
      formData.append('price', this.price);

      formData.append('remaining_photos', JSON.stringify(this.photoUrls));
      formData.append('project', this.project);
      const meta = [];
      const newMeta = [];
      this.layoutItems.forEach((l) => {
        const m = {
          kind: l.kind,
          area: l.area,
          price: String(l.price || '').replace(/\s/g, ''),
          discount: l.discount,
          building: l.building,
          floor: l.floor,
          view: l.view,
        };
        if (l.id) {
          meta.push({ id: l.id, ...m });
        } else if (l.file) {
          formData.append('new_layouts', l.file);
          newMeta.push(m);
        }
      });
      formData.append('layouts_meta', JSON.stringify(meta));
      formData.append('new_layouts_meta', JSON.stringify(newMeta));

      this.newPhotos.forEach((photo) => {
        formData.append('new_photos', photo);
      });

      try {
        const response = await fetch('/api/editObjects', {
          method: 'POST',
          headers: window.tgFetchHeaders(),
          body: formData,
        });
        await this.$store.dispatch('getObjects');

        const result = await response.json();
        if (response.ok) {
          console.log('Данные успешно отправлены:', result);
        } else {
          console.error('Ошибка с сервера:', result);
        }
      } catch (error) {
        console.error('Ошибка отправки:', error);
      }
      this.backToCatalog();
    },
    backToCatalog() {
      this.check = false;
      this.triggerHapticFeedback();
      this.isOpen = false;
      setTimeout(() => {
        this.$emit('backToCatalog');
      }, 250);
    },

    hideKeyboard() {
      if (window.Telegram && window.Telegram.WebApp) {
        window.Telegram.WebApp.closeKeyboard();
      }
    },

    handleFocus() {
      this.triggerHapticFeedback();
      this.contentStyle = {
        padding: '70px 16px 300px 16px',
      };
    },

    handleBlur() {
      window.scrollTo(0, 0);
      this.contentStyle = {
        padding: '70px 16px 16px 16px',
      };
    },
  },
};
</script>

<style lang="scss" module>
@import '../assets/scss/main.scss';

@keyframes show {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}

@keyframes hide {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

.wrapper {
  position: absolute;
  background: $background;
  overflow-y: auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  animation-name: show;
  animation-duration: 0.25s;

  &.hide {
    animation-name: hide;
    animation-duration: 0.26s;
  }
}

.content {
  padding: 70px 16px 50px 16px;
  position: relative;
}

.back {
  position: fixed;
  z-index: 2;
  top: 16px;
  left: 16px;
  width: 39px;
  height: 39px;
}

.img {
  margin-right: 8px;
  width: 12px;
  height: 12px;
}

.hidden {
  display: none;
}

.custom_button {
  margin: 0 auto;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $white;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}

.photo {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  .photo_preview {
    position: relative;
    width: 100%;
    height: 250px;
    overflow: hidden;
    border-radius: 12px;

    .photo_item {
      width: 100%;
      height: -webkit-fill-available;
      object-fit: cover;
    }
  }
}

.remove_button {
  position: absolute;
  display: flex;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 16px 30px;
  background-color: $red;
  color: $white;
  border: none;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  .delete_icon {
    width: 12px;
    margin: 0 8px 0 0;
  }
}

.section {
  font-weight: 600;
  font-size: 13px;
  color: $muted;
  margin: 8px 0 10px;
}

.field {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.field:last-child {
  margin-bottom: 40px;
}

.title {
  width: 72px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  padding: 14px 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $white;
}

.button_transparent {
  flex-grow: 1;
  padding: 14px 0px 14px 16px;
  background-color: transparent;
  color: $white;
  border: 1px solid #3a3a3a;
  background-color: $bg-dark;
  border-radius: 12px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  overflow: auto;
}

.editor_container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  background-color: transparent;
  color: white;
  border: 1px solid $white;
}

.editor .ql-toolbar {
  background-color: transparent;
  border-bottom: 1px solid $white;
  padding: 0 8px;
}

.editor .ql-container {
  padding: 14px 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: white;
  background-color: transparent;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.button_transparent::placeholder {
  color: $white;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.buttons {
  display: block;
  margin: 0 auto;
  width: 100%;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $white;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  margin: 40px auto 10px auto;
}

.remove_card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $red;
  color: $white;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}
</style>

<style>
.p-editor-toolbar {
  display: none !important;
}
</style>
